module.exports = __webpack_public_path__ + "media/pricing/DigitalStorage-mobile-53e8b31c.png";